import React from "react";
import { useNavigate } from "react-router-dom";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import BtnVerify from "../../buttons/BtnVerify";

const Verify = () => {
  const [loading, setloading] = React.useState(false);
  const username = React.useRef();
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  React.useEffect(() => {
    localStorage.clear();
    context.setvalues({ ...context.values, main_menu: undefined });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const _login = async () => {
    try {
      setloading(true);
      const uname = username.current.value;
      if (is_null(uname)) {
        swal("warning", "Please fill the form properly");
        setloading(false)
        return;
      }
      const req = await axiospost("ms_applicant/codeverify", {
        code: uname,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { type, message } = req.data;
      swal(type, message);
      navigate("/");
    } catch ({ message }) {
      swal("warning", message);
    }
    setloading(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-2xl shadow-xl py-8 px-6 sm:px-10">
          <div className="text-center mb-6">
            <img src="/images/college-logo.png" alt="logo" className="h-24 mx-auto mb-4 object-contain" />
            <h4 className="text-xl font-bold text-neutral-900">Adamu Tafawa Balewa College of Education, Kangere</h4>
            <h6 className="text-sm font-medium text-neutral-600 uppercase mt-1">Admission Application Portal</h6>
            <h6 className="text-sm text-neutral-500 mt-1">APPLICANT ACCOUNT VERIFICATION</h6>
          </div>
          <div className="pt-3">
            <div className="mb-4">
              <label htmlFor="emailaddress" className="block text-sm font-medium text-neutral-700 mb-1">Enter verification code sent to your email address</label>
              <input type="email" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition" id="emailaddress" placeholder="Verification Code" ref={username} />
            </div>

            <div className="mt-4">
              {!loading && (
                <button className="w-full py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 transition-colors" onClick={_login}>
                  Verify Account
                </button>
              )}
              {loading && <button className="w-full py-3 bg-primary-600 text-white font-medium rounded-lg opacity-75 cursor-not-allowed">Please wait...</button>}
            </div>
            <div className="mt-3 text-right">
              <BtnVerify />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
